/**
 * Setup webpack public path
 * to enable lazy-including of
 * js chunks
 *
 */
/* global urls:true */
import * as bootstrap from 'bootstrap';
import $ from 'jquery';

import './scripts/forms';
import './scripts/employment-types';
import './scripts/staff-availability';
import './scripts/employment-type-toggle';
import './scripts/search';
import './scripts/staff-required';
import './scripts/gallery';
import './scripts/google-place-autocomplete';
import './scripts/job-filter';
import './scripts/staff-address';
import './scripts/accommodation-visibility';
import './scripts/add-client-to-job';
import './scripts/confirmation-modal';
import './scripts/view-staff';
import './scripts/job-calendar';
import './scripts/select-client';
import './scripts/update-job-number';
import './scripts/send-job-message';
import './scripts/filter-staff';
import './scripts/send-message-to-autocomplete';
import './scripts/duplicate-staff-check';
import './scripts/set-staff-active-status';
import './scripts/staff-manager-selects';
import './scripts/map-pin-drop';
import './scripts/farm-management';
import jobTallies from './scripts/job-tallies-refactored';
import staffAllocationWatcher from './scripts/staff-allocation-watcher';
import { anchorOnClick, anchorOnLoad } from './utils/anchor-scroll';

window.jQuery = $;
window.$ = $;


$(() => {
	// Anchor scroll
	let scrollOffset = 0;

	if ($(window).width() >= 768) {
		scrollOffset = 0;
	}

	anchorOnClick(scrollOffset, 400);
	anchorOnLoad(scrollOffset, 400);

	jobTallies();
	staffAllocationWatcher.init();

	// Expose the watcher globally for debugging and external access
	window.staffAllocationWatcher = staffAllocationWatcher;

});

$(window).resize(() => {

});

